import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Link } from "wouter";

const Cta = () => {
  return (
    <div className="py-16 sm:py-24 bg-gray-50 dark:bg-gray-50">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-900 mb-4 sm:mb-6">
            Ready to take control of your business?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-600 mb-6 sm:mb-8 px-4 sm:px-0">
            Join thousands of freelancers and consultants who use Contraq to save time, stay organized, and get paid faster.
          </p>

          <div className="flex flex-col gap-4 mb-6 sm:mb-6">
            <Link href="/login?tab=register">
              <Button size="lg" className="!bg-blue-600 hover:!bg-blue-700 !text-white !border-0 px-8 py-3 text-base sm:text-lg w-full sm:w-auto">
                Get Started
                <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
              </Button>
            </Link>
            <Link href="/pricing">
              <Button variant="outline" size="lg" className="!bg-white !border-2 !border-gray-300 !text-gray-700 hover:!bg-gray-50 hover:!border-gray-400 px-8 py-3 text-base sm:text-lg w-full sm:w-auto">
                See Pricing
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
          
          <div className="text-xs sm:text-sm text-gray-500 dark:text-gray-500 flex flex-col gap-2 sm:flex-row sm:justify-center sm:gap-6">
            <span className="flex items-center justify-center">✓ Start Free Today</span>
            <span className="flex items-center justify-center">✓ No credit card required</span>
            <span className="flex items-center justify-center">✓ Setup in 5 minutes</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cta; 